module.exports = __webpack_public_path__ + "img/bois2.a734b8b1.svg";